import React, { createContext, useReducer } from 'react';
import PropTypes from 'prop-types';
import ContextDevTool from 'react-context-devtool';
import contractTermsReducer, { initialState } from '../reducers/contractTermsReducer';

export const ContractTermsContext = createContext();

const ContractTemsProvider = ({ children }) => {
  const useContractTermsState = useReducer(contractTermsReducer, initialState);

  return (
    <ContractTermsContext.Provider value={[...useContractTermsState]}>
      <ContextDevTool
        context={ContractTermsContext}
        id="ContractTermsContext"
        displayName="Contract Terms"
      />
      {children}
    </ContractTermsContext.Provider>
  );
};

ContractTemsProvider.propTypes = {
  children: PropTypes.element.isRequired,
};

export default ContractTemsProvider;
